module.exports = __webpack_public_path__ + "static/img/cpjzx_3@2x.9d27a207.png";